import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const ProspectAuditPage = lazyWithRetry(() => import('./pages/ProspectAuditPage'))

const routes: AppRoute[] = [
  {
    path: 'prospect-audits',
    children: [
      {
        index: true,
        element: ProspectAuditPage,
        meta: {
          title: 'prospectAudit.title',
          require: { superAdminOnly: true },
        },
      },
    ],
  },
]

export default routes
